import { create } from "zustand";

export interface PaywallConfig {
  featureName: string;
  requiredPlan: "starter" | "pro" | "enterprise";
  /** Optional one-liner describing why this feature matters */
  featureDescription?: string;
}

interface PaywallModalState extends PaywallConfig {
  isOpen: boolean;
  open: (config: PaywallConfig) => void;
  close: () => void;
}

export const usePaywallModal = create<PaywallModalState>((set) => ({
  isOpen: false,
  featureName: "",
  requiredPlan: "pro",
  featureDescription: undefined,
  open: (config) => set({ isOpen: true, ...config }),
  close: () => set({ isOpen: false, featureName: "", featureDescription: undefined }),
}));
